const wsRegEx = /^\s+/;
export class Replacer {
    constructor(source) {
        this.offsetTable = [];
        this.source = source;
    }
    replace(start, end, replacement) {
        const startOffset = findOffset(this.offsetTable, start);
        const endOffset = findOffset(this.offsetTable, end);
        this.source = this.source.slice(0, start + startOffset) + replacement + this.source.slice(end + endOffset);
        addOffset(this.offsetTable, end, replacement.length - (end + endOffset - start - startOffset));
    }
    remove(start, end, trimWs = false) {
        var _a, _b, _c;
        this.replace(start, end, '');
        if (trimWs) {
            if (typeof trimWs === 'boolean')
                trimWs = wsRegEx;
            const endIndex = this.idx(end);
            const [wsMatch] = (_a = this.source.slice(endIndex).match(trimWs)) !== null && _a !== void 0 ? _a : [];
            this.source = this.source.slice(0, endIndex) + this.source.slice((_b = endIndex + (wsMatch === null || wsMatch === void 0 ? void 0 : wsMatch.length)) !== null && _b !== void 0 ? _b : 0);
            addOffset(this.offsetTable, end, (_c = -(wsMatch === null || wsMatch === void 0 ? void 0 : wsMatch.length)) !== null && _c !== void 0 ? _c : 0);
        }
    }
    idx(idx) {
        return idx + findOffset(this.offsetTable, idx);
    }
}
function addOffset(offsetTable, idx, offset) {
    let i = offsetTable.length, eq = false;
    while (i-- > 0) {
        const [offsetIdx] = offsetTable[i];
        if (offsetIdx < idx || offsetIdx === idx && (eq = true))
            break;
    }
    if (eq)
        offsetTable.splice(i, 1, [idx, offset + offsetTable[i][1]]);
    else
        offsetTable.splice(i + 1, 0, [idx, offset]);
}
function findOffset(offsetTable, idx) {
    let curOffset = 0;
    for (const [offsetIdx, offset] of offsetTable) {
        if (offsetIdx > idx)
            break;
        curOffset += offset;
    }
    return curOffset;
}
//# sourceMappingURL=str.js.map